import React from "react";
import "./Comments.css";

function Comments({ data }) {
  return <div className="comments">{data}</div>;
}

export default Comments;
